<!-- white-block template -->
<template>
  <div class="item_rank_top5_box" :id="item.magazineId">
    <div class="singleRankingWap">
      <div class="singleRankingBox">
        <img
          src="https://www.mag2.com/events/mag2year/2019/images/hedarTrophy.png"
          alt=""
          class="singleRankingTrophyImg"
        /><span class="singleRankingText">{{ item.rank }}</span
        ><span class="singleRankingTextKanji">位</span>
      </div>
      <div class="singleRankingTitleAndInfoBox">
        <div class="singleRankingTitle">{{ item.magazineTitle }}</div>
        <div class="singleMailMagazineInfoBox">
          <span class="singleMailMagazinePrice"
            ><i class="fas fa-yen-sign"></i>
            <span v-if="item.free === 'FALSE'">{{
              item.basicPriceWithTax
            }}</span
            ><span v-else>0</span></span
          ><span class="singleMailMagazineDeliveryDate"
            ><i class="fas fa-sync-alt"></i>{{ item.cycleType }}</span
          >
          <!--SNS-->
          <span class="sns-btnbox clearfix">
            <ul
              class="sns-drop"
              @mouseover="onMouseOverShare"
              @mouseleave="onLeaveFromShare"
            >
              <li>
                <span class="sns-text"
                  >シェアする <i class="fas fa-share-alt-square"></i>
                </span>
                <ul class="sns-btn" v-show="shareButtonsVisible">
                  <li>
                    <a
                      :href="
                          'https://www.facebook.com/sharer/sharer.php?u=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId
                      "
                      onclick="window.open(this.href, 'window ','width = 550, height = 450, personalbar = 0, toolbar = 0, scrollbars = 1, resizable = 1 '); return false;"
                    >
                      <img
                        class="hero_img"
                        src="https://www.mag2.com/events/mag2year/2019/images/Facebook.png"
                      />
                    </a>
                    <a
                      :href="
                          'https://twitter.com/intent/tweet?url=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId +
                            '&text=「まぐまぐ大賞2020」受賞メルマガ - ' +
                            item.categoryName +
                            ' - ' +
                            item.magazineTitle +
                            '&hashtags=まぐまぐ大賞2020'
                      "
                      onclick="window.open(encodeURI(decodeURI(this.href)), ' tweetwindow ', ' width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=1 ' ); return false;'"
                    >
                      <img
                        class="hero_img"
                        src="https://www.mag2.com/events/mag2year/2019/images/Twitter.png"
                      />
                    </a>
                    <a
                      :href="
                        'https://b.hatena.ne.jp/entry/panel/?url=https://www.mag2.com/events/mag2year/2020/category/' +
                          item.categoryId +
                          '.html&btitle=' +
                          item.magazineTitle +
                          ' - まぐまぐ大賞2020結果発表ページ'
                      "
                      target="_blank"
                    >
                      <img
                        class="hero_img"
                        src="https://www.mag2.com/events/mag2year/2019/images/Hatebu.png"
                      />
                    </a>
                    <a
                      :href="
                          'https://social-plugins.line.me/lineit/share?url=https://www.mag2.com/events/mag2year/2020/category/' +
                            item.categoryId +
                            '.html%23' +
                            item.magazineId
                      "
                    >
                      <img
                        class="hero_img"
                        src="https://www.mag2.com/events/mag2year/2019/images/Line.png"
                      />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </span>
          <!--SNS-->
        </div>
        <div class="singleMailMagazineAuthorImgAndCommendBox">
          <div class="singleMailMagazineAuthorImg">
            <img :src="item.coverImage" alt="" class="author_circle" />
          </div>
          <div class="singleMailMagazineAuthorCommentBox">
            <div
              class="singleMailMagazineReadText"
              v-if="item.customMagazineDescription !== ''"
            >
              <p v-html="item.customMagazineDescription"></p>
            </div>
            <div class="singleMailMagazineReadText" v-else>
              <p v-html="item.magazineDescription"></p>
            </div>
            <div class="singleMailMagazineAuthotComment">
              <div v-if="item.authorComment">
                <div class="singleMailMagazineAuthorCommentSubTitle">
                  <i class="fa fa-trophy" aria-hidden="true"></i>受賞者コメント
                </div>
                <p v-html="item.authorComment"></p>
              </div>
              <div v-else-if="item.userComment">
                <div class="singleMailMagazineAuthorCommentSubTitle">
                  <i class="far fa-comment-dots"></i>読者コメント
                </div>
                <p v-html="item.userComment"></p>
              </div>
              <div v-else></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="item.free === 'FALSE'">
        <div v-if="item.firstMonthPayFlag === '0'">
          <!--有料ボタン(初月無料)-->
          <form
            name="registForm_0"
            :action="'https://mypage.mag2.com/ui/subscribe/' + item.magazineId"
            method="get"
          >
            <input
              type="hidden"
              name="reg"
              value="mag2award2020"
              class="hidden blockCenter"
            /><input
              type="submit"
              name="registBtn"
              value="メルマガ登録はこちら"
              class="reg-paybtn"
            />
          </form>
          <!--/有料ボタン(初月無料)-->
        </div>
        <div v-else>
          <!--有料ボタン(初月有料)-->
          <div class="regbtn-wrap top10">
            <form
              name="registForm_0"
              action="https://mypage.mag2.com/subscribe/SubscribePayMagazine2.do"
              method="get"
            >
              <input
                type="hidden"
                name="reg"
                value="mag2award2020"
                class="hidden"
              />
              <input
                :value="item.magazineId"
                name="magazineId"
                type="hidden"
                class="hidden"
              />
              <input
                type="submit"
                name="registBtn"
                value="メルマガ登録はこちら"
                class="reg-paybtn  blockCenter"
              />
            </form>
          </div>
          <!--/有料ボタン(初月有料)-->
        </div>
      </div>
      <div v-else>
        <!--無料ボタン-->
        <div class="v-if-Free">
          <div class="mag2019-free  blockCenter">
            <form
              action="https://regist.mag2.com/reader/Magrdadd"
              method="post"
              class="reg"
            >
              <input
                type="hidden"
                name="reg"
                value="mag2award2020"
                class="hidden"
              /><input
                :value="item.magazineId"
                name="magid"
                type="hidden"
                class="hidden"
              />
              <ul class="ClearFix ">
                <li class="flex_widht70">
                  <p class="supple">
                    無料メルマガ<a
                      href="https://www.mag2.com/terms/reader.html"
                      target="_blank"
                      >登録規約</a
                    >に同意して
                  </p>
                  <input
                    type="email"
                    name="rdemail"
                    class="rdemail rdmail-under freeResisterInput"
                    placeholder="メールアドレスを入力"
                  />
                </li>
                <li class="flex_widht30">
                  <input
                    type="submit"
                    value="無料で登録"
                    name="registBtn"
                    class="rdmail-reg rdmail-under freeResisterButton"
                  />
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
      <!--/無料ボタン-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shareButtonsVisible: false
    }
  },
  methods: {
    onMouseOverShare() {
      this.shareButtonsVisible = true
    },
    onLeaveFromShare() {
      this.shareButtonsVisible = false
    }
  }
}
</script>

<style scoped>
/* category page */
.item_rank_wap_top5 {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 30px;
  position: relative;
  background: #fff;
}

.item_rank_top5_box {
  padding: 32px 82px;
  position: relative;
  border: 0.5px solid #777;
}
.item_rank_top5_box .singleRankingBox {
  display: flex;
  justify-content: flex-start;
  max-height: 80px;
}
.item_rank_top5_box .singleRankingTrophyImg {
  max-width: 37px;
  max-height: 60px;
  display: inline-block;
  border: none;
  align-self: flex-end;
  position: relative;
  top: 3px;
  margin: 0 10px 0 0;
}
.item_rank_top5_box .singleRankingText {
  font-family: 'futura-pt', futura, 'Century Gothic', 游ゴシック体, YuGothic,
    'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 游ゴシック, 'Yu Gothic',
    メイリオ, Meiryo, sans-serif;
  font-size: 82px;
  letter-spacing: 3px;
  color: #d4af37;
  position: relative;
  top: -11px;
  font-style: italic;
  font-weight: 700;
}
.item_rank_top5_box .singleRankingTextKanji {
  font-family: 'futura-pt', futura, 'Century Gothic', 游ゴシック体, YuGothic,
    'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 游ゴシック, 'Yu Gothic',
    メイリオ, Meiryo, sans-serif;
  font-size: 30px;
  color: #d4af37 !important;
  padding: 0;
  line-height: 0;
  font-weight: 800;
  position: relative;
  bottom: 12px;
  font-style: italic;
  font-weight: 700;
  align-self: flex-end;
}
.item_rank_top5_box .singleRankingTitleAndInfoBox {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.item_rank_top5_box .singleRankingTitle {
  font: 16px YuGothic, 'Yu Gothic', sans-serif, Helvetica, 'ヒラギノ角ゴ Pro W3',
    'HiraKakuPro-W3', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', sans-serif;
  line-height: 1.4;
  margin: 0;
  background: #d4af37;
  padding: 17px;
  color: #fff;
  width: 50%;
  max-width: 600px;
  display: inline;
  font-weight: 700;
  text-align: left;
}
.item_rank_top5_box .singleMailMagazineInfoBox {
  width: 50%;
  border-top: solid 1px #d4af37;
  display: flex;
  justify-content: flex-start;
  max-height: 45px;
  margin-top: 11px;
  padding: 10px 8px 0;
  font-size: 12px;
  color: #d4af37;
  flex-wrap: wrap;
}
.item_rank_top5_box .singleMailMagazinePrice {
  margin-right: 10px;
  line-height: 1.4;
  margin-bottom: 5px;
}
.item_rank_top5_box .singleMailMagazineDeliveryDate {
  line-height: 1.4;
  text-align: left;
  margin-bottom: 5px;
}
.item_rank_top5_box .singleMailMagazineDeliveryDate i {
  margin-right: 5px;
}

.singleMailMagazineAuthorCommentSubTitle {
  background: #fff;
  position: relative;
  top: -15px;
  display: inline-block;
  padding-right: 10px;
  color: #d4af37;
}
.singleMailMagazineAuthorCommentSubTitle i {
  margin-right: 5px;
}

.sns-btnbox {
  text-align: right;
  clear: both;
  position: relative;
  align-self: center;
  margin-top: -4px;
  margin-left: auto;
}

.sns-drop {
  *zoom: 1;
  list-style-type: none;
  margin: 0 auto;
  padding: 0;
  float: left;
  font-size: 16px;
}

.sns-drop .sns-text {
  cursor: pointer;
  transition: all 0.3s;
  font-size: 12px;
  color: #d4af37;
  margin-right: 5px;
}

.sns-drop .sns-text i {
  margin-left: 5px;
}

.sns-drop:before,
.sns-drop:after {
  content: '';
  display: table;
}

.sns-drop li {
  position: relative;
  margin: 0 !important;
  padding: 0;
  text-align: right;
  line-height: 1.3;
  min-width: 130px;
}

.sns-drop li .sns-btn {
  list-style: none;
  position: absolute;
  left: 0;
  margin: 0;
  padding: 0;
  top: 30%;
  visibility: hidden;
  transition: 0.5s;
}

.sns-drop li .sns-btn li {
  /*  background: #1b1b1b; */
  /*  box-shadow:0 0 3px #000;*/
  text-align: center;
}

.sns-drop li .sns-btn li a {
  padding: 5px 0;
  text-align: left;
  display: inline-block;
}

.sns-btnbox .sns-btn li a:hover {
  opacity: 0.6;
  transition: all 0.3s;
}

.sns-drop li .sns-btn li img {
  width: 25px;
  transition: all 0.3s;
}

.sns-drop li :hover {
}

.sns-drop li:hover ul {
  top: 17px;
  visibility: visible;
  opacity: 1;
}

.item_rank_top5_box .singleMailMagazineAuthorImgAndCommendBox {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.item_rank_top5_box .singleMailMagazineAuthorImg {
  align-self: center;
  margin: 20px auto 0;
}
.item_rank_top5_box .singleMailMagazineAuthorImg img {
  max-width: 140px;
  margin: 0;
  height: auto;
}
.item_rank_top5_box .singleMailMagazineAuthorCommentBox {
  align-self: center;
  width: 65%;
  padding: 0 20px 0 0;
}
.item_rank_top5_box .singleMailMagazineReadText,
.item_rank_top5_box .singleMailMagazineAuthotComment {
  text-align: left;
  font: 16px YuGothic, 'Yu Gothic', sans-serif, Helvetica, 'ヒラギノ角ゴ Pro W3',
    'HiraKakuPro-W3', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', sans-serif;
  color: #222;
  line-height: 1.8;
  margin-top: 30px;
  word-break: normal;
}
.item_rank_top5_box .singleMailMagazineAuthotComment {
  border-top: solid 1px #d4af37;
}

input[type='button'],
input[type='submit'],
input[type='reset'],
button,
.button {
  text-align: center;
  border-radius: 0;
  color: #fff;
  font-size: 15px;
  /* font-weight: 700; */
  transition: all 0.35s;
  padding: 15px 0;
  border-radius: 3px;
  cursor: pointer;
  background: #ff9800;
  border: none;
  width: 100%;
  max-width: 480px;
  margin: 10px auto 10px;
  display: block;
}

.mag2019-free ul {
  list-style: none;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  flex-wrap: wrap;
  margin: 20px auto;
  align-items: center;
  padding: 0;
  justify-content: space-between;
  max-width: 490px;
}
.mag2019-free ul li {
  text-align: center;
  align-self: flex-end;
  margin-right: 5px;
}
.mag2019-free ul li.flex_widht70 {
  width: calc(70% - 5px);
}
.mag2019-free ul li.flex_widht30 {
  width: calc(30% - 5px);
}
.mag2019-free .supple {
  font-size: 12px;
  margin: 0;
  float: left;
  color: #777;
}

form input[type='text'],
form input[type='email'],
form input[type='password'],
form select,
form textarea {
  position: relative;
  -webkit-appearance: none;
  display: block;
  border: 0;
  outline: 0;
  background: #fff;
  background: rgba(255, 255, 255, 0.75);
  width: 100%;
  padding: 0.1em 0.1em;
  border: solid 1px rgba(0, 0, 0, 0.15);
  -moz-transition: all 0.35s ease-in-out;
  -webkit-transition: all 0.35s ease-in-out;
  -ms-transition: all 0.35s ease-in-out;
  transition: all 0.35s ease-in-out;
}
input.rdemail.rdmail-under {
  font-size: 12px;
  position: relative;
  top: 0px;
  border-radius: 3px;
  line-height: 2.2;
  padding: 4px;
}
.freeResisterButton {
  height: 36px;
  margin: 0 !important;
  padding: 0 !important;
}
.freeResisterInput {
}
</style>
